// AdvancedView.js

import $ from 'jquery';
import _ from 'lodash';

import { View } from 'backbone';
import Immutable from 'immutable';
import contentTemplate from 'properties/advanced-view.ejs';
import propertyViewMapService from 'PropertyViewMapService.js';


class AdvancedView extends View {

    initialize( opts ) {
        this.options = opts || {};

        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = '#propAdvanced';

        return this;
    }

    render() {
        this.$el.empty();
        this.$el.html(this.template(this.model.toJSON()));

        // Render Property Views
        const views = propertyViewMapService.getAdvancedViews(this.model.attributes.factoryKey);
        if (views) {
            views.map( v => {
                var obj = new v.view({model: this.model, el: $(v.el) });
                obj.render();
            });
        }

        return this;
    }
}

export default AdvancedView;
